import * as React from "react";

import {getDataByPage} from "./utils.ts";

/**
 * Custom hook to handle table pagination.
 */
export default function usePagination<T>(
    data: Array<T>,
    initialPage: number,
    pageSize: number,
): {
    page: number;
    pageData: Array<T>;
    setPage: (newPage: number) => void;
} {
    const [page, setPage] = React.useState(initialPage);

    // Reset the page to the initial page when the data changes
    React.useEffect(() => {
        setPage(initialPage);
    }, [data, initialPage]);

    const pageData = React.useMemo(
        () => getDataByPage(data, page, pageSize),
        [page, pageSize, data],
    );

    return {
        setPage,
        page,
        pageData,
    };
}
